<template>
  <a @click="addPlace" class="button-primary block button-icon icon-left">
    <svg height="12" viewBox="0 0 12 12" width="12" xmlns="http://www.w3.org/2000/svg" class="text-white"><path d="m734.333333 280.666667v2.666666h-2.666666c-.36819 0-.666667.298477-.666667.666667s.298477.666667.666667.666667h2.666666v2.666666c0 .36819.298477.666667.666667.666667s.666667-.298477.666667-.666667v-2.666666h2.666666c.36819 0 .666667-.298477.666667-.666667s-.298477-.666667-.666667-.666667h-2.666666v-2.666666c0-.36819-.298477-.666667-.666667-.666667s-.666667.298477-.666667.666667" transform="translate(-729 -278)"/></svg>
    <span>{{ $t('tour_add_to_plan') }}</span>
  </a>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment-timezone'
moment.tz.setDefault('Asia/Tokyo')

export default {
  props: {
    place: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      from: 'map/getFrom'
    })
  },
  methods: {
    addPlace: function () {
      // GoogleAnalytics
      this.$gtag.event("プランにPOI追加", {
        poi_name: this.place.name
      });
      const params = {
        route: this.from.route,
        place: {
          name: this.place.name,
          location: this.place.location
        },
        visit: 60
      }
      if (this.place.genreIds.indexOf('TH6_tag159') != -1) {
        // デフォルトのチェックイン／アウト時間は18:00／10:00(滞在16時間=960分)
        params.visit = 960
        const startTime = this.$store.getters['condition/getTime']
        const checkinTime = moment(startTime).set('hour', 18)
        this.$store.dispatch('condition/updateTime', checkinTime)
        this.$store.dispatch('destinations/spliceDestinationLock', params)
        this.$store.dispatch('destinations/setStay', { route: this.from.route})
      } else {
        this.$store.dispatch('destinations/spliceDestination', params)
      }
      const fromParams = {
        ...this.from.params,
        fromMap: true
      }

      this.$store.dispatch('routes/search')

      this.$router.push({ name: this.from.name, params: fromParams })
    }
  }
}
</script>
